<!--
 * @Autor: 李建鹏
 * @Date: 2022-07-26 21:03:01
 * @LastEditTime: 2022-11-15 11:53:59
 * @Description: 性价比解读组件
-->
<template>
  <div class="cost_popup">
    <z-popup
      v-model="popupShow"
      position="bottom"
      get-container="body"
      class="b2c_cost_performance_wrap"
      :class="platform"
      @close="handlePopupClose"
    >
      <h4 class="pop_title flex-center">
        性价比解读报告
        <div class="close_icon" @click="handlePopupClose"></div>
      </h4>
      <div class="total-wrapper">
        <div class="cost_performance">
          <div v-if="showTips" class="cost_performance_tips" v-html="showTips"></div>
          <div v-if="!showTips && costPerformanceExplainProps.tagList" class="cost_performance_tag">
            <div class="tag_title" @click="rankPopupHandle">
              {{ costPerformanceExplainProps.productName }}
            </div>
            <div v-if="costPerformanceExplainProps.tagList.length" class="tag_list">
              <div
                v-for="(item, index) in costPerformanceExplainProps.tagList"
                :key="index"
                class="item_tag"
              >
                <span :style="{ color: item.type == 1 ? '#000' : '#666' }">{{ item.tagName }}</span>
                <z-tip
                  v-if="item.describeText"
                  :tip="item.describeText"
                  position="right"
                  :offset-left="-3"
                  @show="$emit('burypoint')"
                >
                  <span
                    v-lazy:background-image="
                      `https://pic1.zhuanstatic.com/zhuanzh/7449eb7a-20f4-4bbe-8bea-5caeb08faea1.png`
                    "
                    class="item_tag-icon"
                  ></span>
                </z-tip>
              </div>
            </div>
          </div>
          <div v-if="!showTips && conclusionText" class="cost_performance_title">
            {{ conclusionText.contentPrefix }}
            <span class="special_text" :style="{ color: conclusionText.appendContentBgColor }">{{
              conclusionText.appendContent
            }}</span>
          </div>
          <div class="normal-box">
            <priceChart
              v-if="skuAveragePrice"
              :chartData="{ ...skuAveragePrice, finenessName, originalPrice, platform }"
            />
          </div>
          <div v-if="machineQuality" class="normal-box">
            <qualityCompare :machineQuality="machineQuality" :finenessName="finenessName" />
          </div>
          <div class="normal-box">
            <trendChart v-if="dailyPrice" :chartData="{ ...dailyPrice, platform }" />
          </div>
          <div v-if="popularity" class="normal-box">
            <headDegree :popularity="popularity" />
          </div>
        </div>
        <section
          v-show="costPerformanceExplainProps.showFeedback && feedbackVal"
          v-if="!notFeedBack"
          class="feed-back"
        >
          <z-platform-bch-entry
            type="embed"
            questionnaireId="1763511342633849344"
            :extend="{
              pageName: '性价比解读',
              ...costPerformanceExplainProps.feedbackData,
            }"
            :canBack="1"
            :openType="3"
            :outAppOpenType="2"
            getContainer="body"
            position="right"
            @watchShow="feedbackCallback"
          />
        </section>
      </div>
      <z-button-group v-if="showButton" fixed inside-card keep-position>
        <z-button v-if="isSoldOut" v8 size="large" type="primary" :class="platform" disabled
          >已售出</z-button
        >
        <z-button
          v-else
          :zz-infoid="infoId"
          zz-sortname="立即购买"
          :zz-sectionid="sectionId"
          zz-sortid="1"
          v8
          size="large"
          type="primary"
          :class="platform"
          @click="$emit('clickBuy')"
        >
          <span v-if="platform == 'zz'">
            {{ isAutoReceiveRedPacket ? '领券购买' : btnText }}
          </span>
          <span v-else>{{ btnText }}</span></z-button
        >
      </z-button-group>
    </z-popup>
    <slot :getCostPerformance="getCostPerformance">
      <div
        v-if="costPerformanceExplainProps"
        class="b2c_cost_performance_perf_text flex-space-between"
        :class="platform"
        @click="costPerfHandle"
      >
        <div>
          <span>{{ costPerformanceExplainProps.contentPrefix }}</span
          ><span
            class="special_text"
            :style="{
              color: costPerformanceExplainProps.appendContentBgColor,
            }"
            >{{ costPerformanceExplainProps.appendContent }}</span
          >
        </div>
        <z-icon
          class-prefix="zziconfont"
          :name="platform == 'zlj' ? 'zlj-next-o' : 'arrow-right'"
          :size="platform == 'zlj' ? '24px' : 'inherit'"
          :color="platform == 'zlj' ? '#666' : '#999'"
        />
      </div>
    </slot>
  </div>
</template>

<script>
  import priceChart from './components/priceChart'
  import trendChart from './components/trendChart'
  import headDegree from './components/heatDegree'
  import qualityCompare from './components/qualityCompare'
  import { Popup, Icon, Button, ButtonGroup, Toast, Tip, PlatformBchEntry } from '@zz-common/zz-ui'
  import zzfetch from '@zz/fetch'
  import { getQuery, loadJS } from '../../utils/index'

  export default {
    name: 'costPerformancePopup',
    components: {
      priceChart,
      trendChart,
      headDegree,
      qualityCompare,
      [Popup.name]: Popup,
      [Button.name]: Button,
      [Icon.name]: Icon,
      [ButtonGroup.name]: ButtonGroup,
      [Tip.name]: Tip,
      [PlatformBchEntry.name]: PlatformBchEntry,
    },
    props: {
      platform: {
        type: String,
        default: () => 'zlj',
      },
      infoId: {
        type: String,
        default: () => '',
      },
      costPerformanceExplainProps: {
        type: Object,
        default: () => {
          return null
        },
      },
      // $ 转转卖场需要orderId
      orderId: {
        type: String,
        default: () => '',
      },
      isSoldOut: {
        type: Boolean,
        default: () => false,
      },
      sectionId: {
        type: String,
        default: () => '131',
      },
      showButton: {
        type: Boolean,
        default: () => true,
      },
      notFeedBack: {
        type: Boolean,
        default: false,
      },
      isAutoReceiveRedPacket: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        popupShow: false,
        costPerformanceExplain: {},
        skuAveragePrice: null, // 成色数据
        dailyPrice: null, // 价格趋势数据
        conclusionText: null, //
        popularity: null, //
        machineQuality: null, //
        finenessName: '', // 成色
        originalPrice: 0, // 本机价格
        btnText: '立即购买',
        feedbackVal: true, //组件给的是否展示入口的回调值
      }
    },
    computed: {
      showTips() {
        if (this.platform == 'zlj') {
          return (
            (this.costPerformanceExplainProps &&
              this.costPerformanceExplainProps.premiumTipContent) ||
            ''
          )
        }
        if (this.platform == 'zz') {
          return (
            (this.costPerformanceExplainProps &&
              this.costPerformanceExplainProps.handPricePremiumContent) ||
            ''
          )
        }
        return ''
      },
    },
    provide() {
      return {}
    },
    methods: {
      handlePopupClose() {
        this.popupShow = false
      },
      showPopup() {
        this.popupShow = true
      },
      costPerfHandle() {
        this.$emit('getCostPerformance')
        this.getCostPerformance()
      },
      getEchartsData() {
        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
        })
        const reqUrl =
          this.platform == 'zz' ? '/waresshow/getCostPerformance' : '/zljgoods/getCostPerformance'
        zzfetch({
          url: `https://app.zhuanzhuan.com/zzopen${reqUrl}`,
          params: {
            infoId: this.infoId,
            orderId: this.platform == 'zz' ? this.orderId : undefined,
          },
        })
          .then((res) => {
            const data = res.respData || {}
            const {
              costPerformanceExplain,
              skuAveragePrice,
              dailyPrice,
              popularity,
              machineQuality,
              finenessName,
              originalPrice,
            } = data
            this.skuAveragePrice = skuAveragePrice
            this.dailyPrice = dailyPrice
            this.conclusionText = costPerformanceExplain
            this.machineQuality = machineQuality
            this.popularity = popularity
            this.finenessName = finenessName || ''
            this.originalPrice = originalPrice
            this.popupShow = true
            toast.clear()
          })
          .catch(() => {
            Toast.clear()
          })
      },
      // $ 获取性价比解读信息
      async getCostPerformance() {
        const saleCombineIds = getQuery('saleCombineIds')
        if (saleCombineIds) {
          this.btnText = '加入搭配'
          if (saleCombineIds.split(',').includes(this.infoId)) {
            this.btnText = '已加入'
          }
        }

        // else if (this.platform == 'zz') {
        //   this.isAutoReceiveRedPacket ? (this.btnText = '领券购买') : (this.btnText = '立即购买')
        // }
        // this.getEchartsData()
        if (window.echarts) {
          this.getEchartsData()
        } else {
          await loadJS('https://s1.zhuanstatic.com/common/u/echarts.min.js', () => {
            //给200ms echarts 加载
            setTimeout(() => this.getEchartsData(), 200)
          })
        }
      },
      // $ 同款同成色超低价 提示弹窗
      rankPopupHandle(item) {
        console.log('-------->>>   rankPopupHandle', item, this.costPerformanceExplainProps)
      },
      feedbackCallback(val) {
        this.feedbackVal = !!val
      },
    },
  }
</script>

<style lang="scss">
  @import '../../assets/styles/zlj.common.scss';

  .total-wrapper {
    padding-bottom: 136px;
    overflow: auto;

    .feed-back {
      margin-top: 20px;
    }
  }

  .b2c_cost_performance_wrap {
    height: 80vh;
    background: #f5f7f8 !important;
    flex-direction: column;
    display: flex;
    box-sizing: border-box;

    &.z-iphone-x {
      padding-bottom: 0 !important;
    }

    .pop_title {
      height: 80px;
      margin: 24px 0;
      font-size: 32px;
      position: relative;
      font-weight: 500;
      color: #000;
      line-height: 40px;
      flex-shrink: 0;
      .close_icon {
        position: absolute;
        width: 56px;
        height: 56px;
        top: 12px;
        right: 20px;
        background: url('https://cdn.huodao.hk/upload_img/20200702/c5e05b20427386411b30fb250e5b22e3.png');
        background-size: 100%;
      }
    }

    .cost_performance {
      padding: 0 32px;
      &_tips {
        font-size: 28px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #111;
        margin-bottom: 35px;
        max-height: 150px;
        overflow-y: scroll;
        // &::-webkit-scrollbar {
        //   display: none;
        // }
      }
      &_tag {
        position: relative;
        padding-bottom: 47px;
        margin-bottom: 35px;
        &::after {
          content: ' ';
          position: absolute;
          bottom: 0px;
          width: 200%;
          height: 1px;
          border-bottom: 1px solid #d8d8d8;
          transform-origin: 0 0;
          transform: scale(0.5) translateY(-50%);
        }
        .tag_title {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000;
          line-height: 30px;
        }
        .tag_list {
          margin-top: 19px;
          display: flex;
          flex-wrap: wrap;
          white-space: nowrap;
          .item_tag {
            height: 20px;
            position: relative;
            display: flex;
            align-items: center;
            padding-left: 37px;
            margin-bottom: 5px;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
            .z-tip-trigger {
              display: flex;
              .z-tip {
                padding: 16px 4px 16px 16px;
              }
              .z-tip-content {
                max-width: 350px;
                font-size: 20px;
                line-height: 1.5;
                white-space: normal;
              }
            }
            &::before {
              content: ' ';
              position: absolute;
              left: 18px;
              top: 50%;
              width: 1px;
              height: 32px;
              border-right: 1px solid #d8d8d8;
              transform-origin: 0 0;
              transform: scale(0.5) translateY(-50%);
            }
            &-icon {
              display: inline-block;
              width: 28px;
              height: 28px;
              background-repeat: no-repeat;
              background-size: 100%;
            }
          }
          .item_tag:first-child {
            padding-left: 0;
            &::before {
              display: none;
            }
          }
        }
      }
      &_title {
        color: #666666;
        font-size: 28px;
        margin-bottom: 40px;
        // position: sticky;
        top: -1px;
        z-index: 99;
        background-color: #f5f7f8;
      }
    }

    .z-button-group__default {
      flex-direction: column;
    }
    .special_text {
      color: #112a7f;
    }

    .normal-box {
      background: #ffffff;
      border-radius: 20px;
      margin-bottom: 24px;
      padding: 0 24px;

      &:last-of-type {
        margin-bottom: 0;
      }

      .title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 90px;
      }

      .highlight {
        position: relative;
        z-index: 2;

        &::after {
          content: '';
          height: 10px;
          background: #ffc1c1;
          border-radius: 2px;
          position: absolute;
          bottom: 5px;
          left: -3px;
          right: -3px;
          opacity: 0.8;
          z-index: -1;
        }
      }
    }

    .z-button.zlj {
      height: 104px;
      border-radius: 16px;
      font-size: 32px;

      &::after {
        border-color: inherit;
        border: none !important;
      }
    }
    .z-button.zz {
      background: #ff483c;
    }
  }

  .b2c_cost_performance_wrap.zz {
    background: #fafafa !important;
    .pop_title {
      color: #111111;
      line-height: 45px;
    }

    .cost_performance_title {
      background: #fafafa !important;
    }
  }

  .b2c_cost_performance_perf_text {
    height: 60px;
    padding: 0 16px;
    background: #f8f9fd;
    border-radius: 8px;
    align-items: center;
    color: #666666;
    font-size: 22px;

    .special_text {
      color: #112a7f;
    }
  }
  .zz.b2c_cost_performance_perf_text {
    padding: 0 16px 0 24px;
  }

  .zlj.b2c_cost_performance_perf_text {
    padding-right: 8px;
  }
</style>
